import { useState } from 'react'
import { Box, Menu, MenuItem } from '@mui/material'
import KeyboardArrowDownIcon from '@mui/icons-material/KeyboardArrowDown'
import { STATE_DEFS } from '../common/constants'
import { useCloseOnAnchorHidden } from '../common/useCloseOnAnchorHidden'
import StatePill from './StatePill'

interface StatePickerProps {
  state: string
  onChange: (state: string) => void
}

// Click-to-change state pill. Uses StatePill for the visual so the picker
// always matches the static pill rendered in lists / paginators / chips.
export default function StatePicker({ state, onChange }: StatePickerProps) {
  const [anchor, setAnchor] = useState<HTMLElement | null>(null)
  // Close when the trigger drops out of layout (tab switch hides the
  // whole subtree via `display: none`). Otherwise MUI logs an invalid
  // anchorEl warning against a still-mounted-but-hidden anchor.
  useCloseOnAnchorHidden(anchor, () => setAnchor(null))

  return (
    <>
      <Box
        onClick={(e) => setAnchor(e.currentTarget)}
        sx={{ display: 'inline-flex', cursor: 'pointer', userSelect: 'none' }}
      >
        <StatePill
          state={state}
          trailing={<KeyboardArrowDownIcon sx={{ fontSize: 12, ml: -0.25, opacity: 0.8 }} />}
        />
      </Box>
      <Menu
        anchorEl={anchor}
        open={Boolean(anchor)}
        onClose={() => setAnchor(null)}
        anchorOrigin={{ vertical: 'bottom', horizontal: 'left' }}
        transformOrigin={{ vertical: 'top', horizontal: 'left' }}
      >
        {STATE_DEFS.map((s) => (
          <MenuItem
            key={s.key}
            onClick={() => { setAnchor(null); onChange(s.key) }}
            sx={{ py: 0.5, px: 1 }}
          >
            <StatePill state={s.key} />
          </MenuItem>
        ))}
      </Menu>
    </>
  )
}

